module.exports = __webpack_public_path__ + "img/zcyTwo.d561e388.png";